"use strict";

angular.module("core")
.service("ZebraPrinterService", function($q, gettextCatalog, cfpLoadingBar, ModalService, FlashBag, $cookies) {
    var LAST_USED_ZEBRA_PRINTER_COOKIE_KEY = "last-used-zebra-printer";
    var zebra = null;
    var _this = this;
    var permissions = null;

    document.addEventListener("deviceready", function() {
        zebra = window.ZebraPrinter;
        permissions = cordova.plugins.permissions;
    });

    this.isSupported = function() {
        return !!zebra;
    };

    Object.defineProperty(
        this,
        "hasFavouritePrinter",
        {
            get: function() {
                return !!$cookies.get(LAST_USED_ZEBRA_PRINTER_COOKIE_KEY)
            }
        }
    );

    function printUsingPrinter(deferred, printer, filename, data) {
        deferred.promise.then(function onSuccess(value) {
            var expirationDaysDelta = 30;
            var expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() + expirationDaysDelta);
            $cookies.put(LAST_USED_ZEBRA_PRINTER_COOKIE_KEY, printer.address, {
                expires: expirationDate
            });
        })
        cfpLoadingBar.start();
        zebra.printPDF(printer, filename, data, deferred.resolve, function onError(errors) {
            var errorStrings = errors.map(function(error) {
                switch (error) {
                    case "BLUETOOTH_IS_NOT_ENABLED":
                        return gettextCatalog.getString("Bluetooth is not enabled.");
                    case "ZEBRA_PDF_DIRECT_ERROR":
                        return gettextCatalog.getString("Zebra PDFDirect is not installed or enabled on printer.");
                    case "UNABLE_TO_OPEN_A_CONNECTION_TO_PRINTER":
                        return gettextCatalog.getString("Unable to open a connection to Zebra printer.");
                    case "NOT_CONTINUOUS_MEDIA_TYPE":
                        return gettextCatalog.getString("Zebra Printer is not configured with continuous media type.");
                    case "UNRECOGNIZED_PRINTER":
                        return gettextCatalog.getString("Unable to recognize printer.");
                    case "UNABLE_TO_PRINT":
                        return gettextCatalog.getString("Unable to send the data to printer.");
                    // See: https://techdocs.zebra.com/link-os/2-12/pc/content/constant-values.html  com.zebra.sdk.printer.PrinterStatusMessages
                    case "HEAD OPEN":
                        return gettextCatalog.getString("ZEBRA_STATUS: HEAD OPEN");
                    case "HEAD TOO HOT":
                        return gettextCatalog.getString("ZEBRA_STATUS: HEAD TOO HOT");
                    case "INVALID STATUS":
                        return gettextCatalog.getString("ZEBRA_STATUS: INVALID STATUS");
                    case "PAPER OUT":
                        return gettextCatalog.getString("ZEBRA_STATUS: PAPER OUT");
                    case "PAUSE":
                        return gettextCatalog.getString("ZEBRA_STATUS: PAUSE");
                    case "RECEIVE BUFFER FULL":
                        return gettextCatalog.getString("ZEBRA_STATUS: RECEIVE BUFFER FULL");
                    case "RIBBON OUT":
                        return gettextCatalog.getString("ZEBRA_STATUS: RIBBON OUT");
                    default:
                        return error;
                }
            });

            deferred.reject(errorStrings.join("\n"));
        })
        deferred.promise.finally(function onFinally() {
            cfpLoadingBar.complete();
        })
    }

    this.validatePermission = function(success, failure) {
        if (!permissions) {
            success();
            return;
        }

        var list = [
            permissions.BLUETOOTH_SCAN,
            permissions.BLUETOOTH_CONNECT,
            permissions.BLUETOOTH_ADMIN
        ];

        function onError() {
            failure(gettextCatalog.getString("Bluetooth permission are not turned on."));
        }

        function onCheckPermissionCompleted(status) {
            if (!status.hasPermission) {
                permissions.requestPermissions(
                    list,
                    function onRequestPermissionCompleted(requestStatus) {
                        if (requestStatus.hasPermission) {
                            success();
                        } else {
                            onError();
                        }
                    },
                    onError);
            } else {
                success();
            }
        }

        permissions.checkPermission(list, onCheckPermissionCompleted, null);
    }

    this.print = function(filename, data, forceSelectPrinter) {
        var deferred = $q.defer();
        if (!zebra) {
            deferred.reject("Zebra Printer is not supported.");  // <- it means there is a bug on the site
        }
        else {
            this.validatePermission(
                function onPermissionSuccess() {
                    zebra.getBLEPrinters(
                        function onSuccess(printers) {
                            if (printers.length === 0) {
                                deferred.reject(gettextCatalog.getString("No Zebra printers are connected."));
                            }
                            else {
                                var recentPrinterAddress = $cookies.get(LAST_USED_ZEBRA_PRINTER_COOKIE_KEY);
                                var selectedPrinter = recentPrinterAddress ? _.find(printers, function(p) {
                                    return p.address === recentPrinterAddress;
                                }) : null;

                                if (selectedPrinter && !forceSelectPrinter) {
                                    printUsingPrinter(deferred, selectedPrinter, filename, data);
                                }
                                else {
                                    ModalService.showModal({
                                        templateUrl: require("./zebra-printer-select.modal.html"),
                                        controller: "ZebraPrinterSelectModal",
                                        controllerAs: "zebraPrinterSelectModalCtrl",
                                        inputs: {
                                            $attrs: {
                                                selectedPrinter: selectedPrinter,
                                                printers: printers
                                            }
                                        }
                                    }).then(function(modal) {
                                        modal.element.modal({
                                            backdrop: "static",
                                            keyboard: false
                                        });
                                        return modal.close.then(function(selectedPrinter) {
                                            if (selectedPrinter) {
                                                printUsingPrinter(deferred, selectedPrinter, filename, data);
                                            }
                                            else {
                                                deferred.reject(gettextCatalog.getString("Printing was cancelled."));
                                            }
                                            return selectedPrinter;
                                        });
                                    });
                                }
                            }
                        },
                        function onError(errors) {
                            deferred.reject(errors.join("\n"));
                        }
                    );
                },
                function onPermissionError(reason) {
                    deferred.reject(reason);
                }
            )
        }
        return deferred.promise;
    };

    this.resetFavouritePrinter = function() {
        $cookies.remove(LAST_USED_ZEBRA_PRINTER_COOKIE_KEY);
    };

    this.defaultResponseCallback = function(data, forceSelectPrinter) {
        var fileData = data.file_data;
        if (fileData) {
            var fileName = data.file_name;
            return _this.print(
                fileName,
                fileData,
                forceSelectPrinter
            ).then(function onSuccess() {
                    FlashBag.success(
                        "Printed successfully",
                        false,
                        undefined,
                        true
                    );
                },
                function onError(reason) {
                    FlashBag.error(reason);
                    return $q.reject(reason);
                }
            );
        }
        else {
            var reason = gettextCatalog.getString("There is an error while trying to generate the file.");
            FlashBag.preformattedError(reason);
            return $q.reject(reason);
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/zebra-printer/zebra-printer.service.js
// module id = 436
// module chunks = 0